export const loanCalculatorData = [
  {
    id: 1,
    heading:
      "AXIS Bank Personal Loan EMI Calculator: Manage Your Finances with Precision",
    subHeading:
      "Use the AXIS Bank Personal Loan EMI Calculator to quickly estimate your monthly repayment amount. Whether you're looking to cover unexpected expenses, fund a personal project, or consolidate existing debts, understanding your monthly EMI can help you plan your finances better. With AXIS Bank’s EMI calculator, you can calculate your EMI accurately and make well-informed decisions.",

    notice:
      "The calculations provided are for illustrative purposes only. Actual loan terms may vary based on the lender’s policies and your credit profile.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
